<button mat-dialog-title mat-mini-fab color="primary" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  @if(data.photoAngleData) {
  <h1>{{ data.photoAngleData.Name | translate }}</h1>
  }
  @else {
  <h1>{{'T4.Settings.PhotoAngleDialog.createPhotoAngle' | translate:'Create New Photo Angle' }}</h1>
  }
  <t4-container>
      <div class="row">
        <div class="col-3">
          <img src="data:image/png;base64,{{image.Data}}" style="width: 133px; height: 133px; object-fit: contain; margin-bottom: 30px;" />
          <input #txtFile type="file" style="visibility:hidden" (change)="upload($event.target.files)" />
          <button mat-mini-fab title="{{ 'Turbo.Settings.EditCategoryDialog.tipChangeImage' | translate : 'Change image' }}" style="position: absolute; left: 61px; bottom: 5px;" (click)="beginUpload()"><mat-icon>upload</mat-icon></button>
        </div>
        <div class="col-9">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.Settings.PhotoAngleDialog.lblKey' | translate : 'Key' }}</mat-label>
            <input matInput [(ngModel)]="photoAngle.Key" autocomplete="off" required (blur)="onKeyBlur()">
          </mat-form-field>
          @if(translationKey)
          {
          <!--<div *ngIf="isLoading" class="loader">Loading...</div>-->
          <ng-container>
            <div class="row">
              <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.PhotoAngleDialog.lblName' | translate : 'Name' }}</div>
              <div class="col-10">
                <t4-translation-editor [translationKey]="'T4.Data.PhotoAngle.'+ data.typeClassId + '.' + translationKey +'.Name'"></t4-translation-editor>
              </div>
            </div>
            <div class="row">
              <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.PhotoAngleDialog.lblDescription' | translate : 'Description' }}</div>
              <div class="col-10">
                <t4-translation-editor [translationKey]="'T4.Data.PhotoAngle.'+ data.typeClassId + '.' + translationKey +'.Description'"></t4-translation-editor>
              </div>
            </div>
          </ng-container>
          }
        </div>
      </div>
  </t4-container>

</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end">
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!photoAngle.Key" (click)="save()">{{ 'Turbo.Settings.PhotoAngleDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.PhotoAngleDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>

